;(() => {
  const detailsSelectors = []

  class DetailsItem {
    constructor(classSelector, parent) {
      this.classSelector = classSelector
      this.parent = parent
      this.$parent = $(this.parent)
      this.$parent.attr("details", "on")
      this.title = this.parent.querySelector(`.${this.classSelector}--title`)
      this.content = this.parent.querySelector(`.${this.classSelector}`)
      this.contentSave = this.content.getAttribute("data-content-save") || false

      if (this.content.dataset.template) {
        const template = document.getElementById(this.content.dataset.template)
        if (template) {
          this.content.innerHTML = template.innerText
        } else {
          Bugsnag.notify(
            `Glossary term template missing: ${this.content.dataset.template}`,
          )
        }
      }

      this.contentPrevSibling = this.content.previousSibling
      this.closingDuration = $(this.content).hasClass(
        `${this.classSelector}_nodelay`,
      )
        ? 0
        : 150
      this.isOpened = this.parent.classList.contains(
        `${this.classSelector}--container_opened`,
      )
      if (!this.isOpened) {
        this.removeContent()
      }

      $(this.title).on("click", (event) => {
        if (
          !this.$parent.hasClass(`${this.classSelector}--container_clickable`)
        ) {
          event.preventDefault()
          event.stopPropagation()
        }
        this.clickHandler()
      })

      this.$parent.on("details:trigger-close", () => {
        if (this.isOpened) {
          this.close()
        }
      })

      this.$parent.on("details:open", initAllNewDetails)
    }

    clickHandler() {
      if (this.isOpened) {
        this.close()
      } else {
        this.open()
      }
    }

    open() {
      this.$parent.addClass(`${this.classSelector}--container_opened`)
      this.returnContent()
      this.$parent.trigger("details:open")
      this.isOpened = true
    }

    close() {
      this.$parent.addClass(`${this.classSelector}--container_closing`)
      setTimeout(() => {
        this.removeContent()
        this.$parent
          .removeClass(`${this.classSelector}--container_closing`)
          .removeClass(`${this.classSelector}--container_opened`)
          .trigger("details:close")
      }, this.closingDuration)
      this.isOpened = false
    }

    // Remove content from the DOM to increase page performance
    removeContent() {
      if (!this.contentSave) {
        this.content.parentNode.removeChild(this.content)
      }
    }

    returnContent() {
      if (!this.contentSave) {
        this.contentPrevSibling.parentNode.insertBefore(
          this.content,
          this.contentPrevSibling.nextSibling,
        )
      }
    }
  }

  function details(classSelector) {
    if (!detailsSelectors.includes(classSelector)) {
      detailsSelectors.push(classSelector)
    }

    $(`.${classSelector}--container:not([details=on])`).each(
      function initDetail() {
        new DetailsItem(classSelector, this)
      },
    )
  }

  window.HB = window.HB || {}
  window.HB.details = details

  window.HB.tooltips = window.HB.tooltips || {}
  window.HB.tooltips.initAll = function initAll() {
    if (!window.HB.details) return
    window.HB.details("details")
    if (window.HB.isMobile) window.HB.details("tooltip")
  }

  function initAllNewDetails() {
    detailsSelectors.forEach((selector) => {
      details(selector)
    })
  }

  $(() => {
    details("details")

    const throttleInit = HB.throttle(initAllNewDetails, 200)
    const observer = new MutationObserver(throttleInit)
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
    })
  })
})()
